import { InjectionToken } from "@angular/core";

export interface ConfirmationModalOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

/**
 * Injection token used internally to provide {@link ConfirmationModalOptions}
 */
export const CONFIRMATION_MODAL_OPTIONS: InjectionToken<
  ConfirmationModalOptions
> = new InjectionToken("CONFIRMATION_MODAL_OPTIONS");
